module.exports = __webpack_public_path__ + "img/exclamation-circle.25a4e9ad.svg";